<template>
    <Link :href="href" :class="classes">
        <slot />
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';

    export default {
        components: {
            Link,
        },
        props: ['href', 'active'],

        computed: {
            classes() {
                return this.active
        
                     ? 'text-gray-600 transition duration-150 ease-in-out hover:text-gray-500 focus:text-gray-500 active:text-neutral-600 dark:text-gray-600 dark:hover:text-gray-600 dark:focus:text-gray-600 dark:active:text-gray-600 text-xs no-underline '
                    // : 'inline-flex items-center px-4 pt-1  border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition'
                  :  'text-gray-600 transition duration-150 ease-in-out hover:text-gray-500 focus:text-gray-500 active:text-neutral-600 dark:text-gray-600 dark:hover:text-gray-600 dark:focus:text-gray-600 dark:active:text-gray-600 text-xs no-underline '
            }
        }
    }
</script>

<style >
.no-underline{
    text-decoration: none !important; 
}
</style>
